import { Component, OnInit, HostBinding } from '@angular/core';

@Component({
  selector: 'app-security-layout',
  templateUrl: './security-layout.component.html',
  styleUrls: ['./security-layout.component.scss']
})
export class SecurityLayoutComponent {
  @HostBinding('class') readonly hostClasses = 'has-navbar-fixed-top';
}
